export class KeyName {
    static BACKSPACE = 'Backspace';
    static TAB = 'Tab';
    static ENTER = 'Enter';
    static SHIFT = 'Shift';
    static ESCAPE = 'Escape';
    static SPACE = ' ';
    static LEFT = 'ArrowLeft';
    static UP = 'ArrowUp';
    static RIGHT = 'ArrowRight';
    static DOWN = 'ArrowDown';
    static DELETE = 'Delete';

    // IE11 & Edge treat the numpad del key differently - with numlock on we get "Del" for key
    static NUM_PAD_DELETE = 'Del';

    static A = 'a';
    static C = 'c';
    static V = 'v';
    static D = 'd';
    static Z = 'z';
    static Y = 'y';

    static F2 = 'F2';

    static PAGE_UP = 'PageUp';
    static PAGE_DOWN = 'PageDown';
    static PAGE_HOME = 'Home';
    static PAGE_END = 'End';
}
